// extracted by mini-css-extract-plugin
export default {"productLabelImage":"ProductLabel-productLabelImage-1ez","productLabelText":"ProductLabel-productLabelText-Rt2","productLabelTextMicro":"ProductLabel-productLabelTextMicro-pSb"};